<template>
  <StudentAdmission v-if="dashboardRole === 'student'" />
  <TeacherDashboard v-else-if="dashboardRole === 'teacher'" />
  <AdminDashboard v-else-if="dashboardRole === 'admin'" />
</template>

<script>
import Login from '@/utils/login';
import ROLE from '@/utils/roles';

export default {
  name: 'DashboardEntry',
  components: {
    StudentAdmission: () => import('@/views/student/Admission'),
    TeacherDashboard: () => import('./Teacher'),
    AdminDashboard: () => import('./Admin')
  },
  data: () => ({
    dashboardRole: ''
  }),
  async created() {
    const loginData = Login.lastLoginData;
    const userType = Login.lastRole;

    if (!loginData) {
      Login.redirectToLogin();
    } else if (loginData.is_dl) {
      this.$router.replace({ name: 'deans-list' });
    } else if (userType === ROLE.STUDENT) {
      this.dashboardRole = 'student';
    } else if (userType === ROLE.SCHOOL) {
      this.$router.replace({ name: 'school-studentApply' });
    } else if (userType === ROLE.TEACHER) {
      await this.$teacher.getInfo();
      this.dashboardRole = this.$teacher.isAdmin ? 'admin' : 'teacher';
    } else {
      this.$router.replace({ name: 'Home' });
    }
  }
};
</script>
